import ComposerBody from 'flarum/components/ComposerBody';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';
import replaceContent from "../helpers/replaceContent";

function minimizeComposerIfFullScreen(e) {
  if (app.composer.isFullScreen()) {
    app.composer.minimize();
    e.stopPropagation();
  }
}

export default class AdvPostEditor extends ComposerBody {
  oninit(vnode) {
    super.oninit(vnode);
    // this.postComments = this.attrs.post.data.attributes.advcomments;
    this.postComments = this.attrs.postComments;
  }

  static initAttrs(attrs) {
    super.initAttrs(attrs);

    attrs.submitLabel = attrs.submitLabel || app.translator.trans('tolyod-advdiscus.forum.composer_edit.submit_button');
    attrs.confirmExit = attrs.confirmExit || app.translator.trans('tolyod-advdiscus.forum.composer_edit.discard_confirmation');
    attrs.originalContent = '';
    attrs.user = attrs.user || attrs.post.user();

    attrs.post.editedContent = attrs.originalContent;
  }

  data() {
    return {
      content: this.composer.fields.content(),
    };
  }

  onsubmit(e) {
    this.loading = true;
    const { content } = this.data();
    const postId = this.attrs.post.id();
    const discussionId = this.attrs.post.discussion().id();
    const newAdvCommentRecord = app.store.createRecord("advcomments");

    newAdvCommentRecord
      .save({
        content,
        post_id: postId,
        discussion_id: discussionId,
      })
      .then((r) => {
        const attrs = r.data.attributes;

        const newAdvComment = app.store.getById('advcomments', attrs.id);
        console.log(newAdvComment);
        console.log(this.postComments());

        const newComments = [...this.postComments(), newAdvComment];
        this.postComments(newComments);
        console.log(this.postComments());
        const stream = app.current.get("stream");
        if (!!stream) {
          stream.update();//.then(() => stream.goToNumber(this.attrs.post.number()));
        }
        this.composer.hide();
        m.redraw();
        this.loading = false;
        // location.reload();
      }, this.loaded.bind(this));
    return false;
  }

  headerItems() {
    const items = super.headerItems();
    const post = this.attrs.post;

    items.add(
      'title',
      <h3>
        {icon('fas fa-pencil-alt')}{' '}
        <Link href={app.route.discussion(post.discussion(), post.number())} onclick={minimizeComposerIfFullScreen}>
          {app.translator.trans('core.forum.composer_edit.post_link', { number: post.number(), discussion: post.discussion().title() })}
        </Link>
      </h3>
    );

    return items;
  }
}
